const USER_MANUAL_PDF_URL = process.env.API_URL + '/user-manual';

const getPdfUserManual = (context) => {
  return context.$http.get(USER_MANUAL_PDF_URL, {responseType: 'arraybuffer'});
};

export default {
  getPdfUserManual
};



// WEBPACK FOOTER //
// ./src/api/userManual/userManualHttp.js